module.exports = __webpack_public_path__ + "static/media/onboarding-phones.en.a1d3e526.png";